import { DollarSign, TrendingDown, Wallet, Activity } from "lucide-react";

export function CumulativeTooltip({ active, payload, label }: any) {
    if (!active || !payload?.length) return null;

    const toLabel = (k: string) =>
        k === "investment" ? "Investment" :
            k === "savings" ? "Annual Savings" :
                k === "cumulativeValue" ? "Cumulative Value" : k;

    const iconFor = (k: string) =>
        k === "investment" ? <TrendingDown className="w-4 h-4 text-blue-400" /> :
            k === "savings" ? <Wallet className="w-4 h-4 text-teal-400" /> :
                k === "cumulativeValue" ? <Activity className="w-4 h-4 text-cyan-400" /> :
                    <DollarSign className="w-4 h-4 text-gray-400" />;

    const fmt = (v: number) =>
        v >= 1_000_000 ? `$${(v/1_000_000).toFixed(1)}M` :
            v >= 1_000 ? `$${(v/1_000).toFixed(0)}K` :
                `$${(v||0).toLocaleString()}`;

    return (
        <div className="financial-tooltip-container">
            <p className="text-teal-100 font-bold text-lg mb-3">{label}</p>
            {payload.map((e: any, i: number) => (
                <div key={i} className="flex items-center gap-3 mb-2">
                    {iconFor(e.dataKey)}
                    <span className="text-slate-200 font-medium">{toLabel(e.dataKey)}:</span>
                    <span className="text-white font-bold">{fmt(Number(e.value)||0)}</span>
                </div>
            ))}
        </div>
    );
}